import { useCallback } from 'react'

import useCvip from './useCvip'
import { useWallet } from 'use-wallet'

import { unstake, getMasterChefContract } from '../cvip/utils'

const useUnstake = (pid: number) => {
  const { account } = useWallet()
  const cvip = useCvip()
  const masterChefContract = getMasterChefContract(cvip)

  const handleUnstake = useCallback(
    async (amount: string) => {
      const txHash = await unstake(masterChefContract, pid, amount, account)
      console.log(txHash)
    },
    [account, pid, cvip],
  )

  return { onUnstake: handleUnstake }
}

export default useUnstake
